import React, { useState } from "react";
import RequestService from "../../services/request.service";

import { toast } from 'react-toastify'

import moment from 'moment'
import 'moment/locale/es'



import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";



import { Form  } from 'react-bootstrap';

import Select from 'react-select';



export interface labelType {
  readonly value: string;
  readonly label: string;
  readonly color: string;
  readonly isFixed?: boolean;
  readonly isDisabled?: boolean;
}


const DirectorComercial = () =>{




  const [ sucursales, setSucursales ] = useState<any>([])
  const cargarSucursales = async()=>{
    try{
      
      let response : any = await RequestService.getEndPoint('sucursales')
      // let suc : any = response.data
      let sucursales : any = response.data.map( sucursal =>{ return  { value :  sucursal.uuid, label : sucursal.nombre_sucursal } })
      setSucursales(sucursales)
    }
    catch(e){
      toast.error('Problemas al intentar cargar sucursales')
    }
  }


      React.useEffect(() => {
        cargarSucursales()
      }, []);

      const defaultValue : labelType[] = []
      const [ etiquetas_seleccionadas, setEtiquetasSeleccionada ] = useState<any>([])
      const [ etiquetas_seleccionadas_, setEtiquetasSeleccionada_ ] = useState<any>([])





  const descargarReporte = async() => {
    let res = await RequestService.downloadFile('mesa_atencion/excel/'+moment(startDate).format('YYYY-MM-DD')+'/'+moment(endDate).format('YYYY-MM-DD'))
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${Date.now()}.xlsx`);
    document.body.appendChild(link);
    link.click();
  }



  const [ cargando_, setCargando ] = useState( true )


  const [ reporte, setReporte ] = useState<any>({
    sucursal : {
      nombre_sucursal : ""
    },
    RowsAcumuladosTotales : {
                  total_captura : 0,
                  total_mesa : 0,
                  total_rectificacion : 0,
                  total_aseguramiento : 0,
                  total_sin_pagar : 0,
                  total_liquidado : 0,
                  total_penalizado : 0,
                  total_verificacion_telefonica : 0,
                  total_verificacion_final : 0,
                  total_canceladas : 0
                }
  })

  const cargarMiReporte = async()=>{
    try{
      setCargando(true)
      // var uuid_sucursal = "mmm"
      let uuids_sucursales = etiquetas_seleccionadas.map( (sucursal:any)=> sucursal.value )
      var ED = endDate ? moment(endDate).format('YYYY-MM-DD') : null
      let response = await RequestService.getEndPointPost('reporte-director-comercial/'+moment(startDate).format('YYYY-MM-DD')+'/'+ ED, { sucursales : uuids_sucursales } )
      setReporte(response.data)
      setCargando(false)

      setStartDate_(startDate)
      setEndDate_(endDate)
      setEtiquetasSeleccionada_([...etiquetas_seleccionadas])
      // toast.success('La lista de Tramites del día '+fecha+' fue cargada')
    }
    catch(e){
      setCargando(false)
      toast.error('Problemas al intentar generar tu reporte. Contacta con los administradores del sistema')
    }
  }


  React.useEffect(() => {
    cargarMiReporte()
  }, []);




  const [ arreglo_estatus, setEstatus ] = useState<any>([true,true,true,true,true,true,true,true,true,true])


  const todos = () =>{
    setEstatus([true,true,true,true,true,true,true,true,true,true])
  }
  const ninguno = () =>{
    setEstatus([false,false,false,false,false,false,false,false,false,false])
  }




  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());


  const [startDate_, setStartDate_] = useState(new Date());
  const [endDate_, setEndDate_] = useState(new Date());


  const onChangeRango = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    // cargarMiReporte()
  };




  const [ showModalListaGerente, setShowModalListaGerente ] = useState<boolean>(false)
  const [ uuid_gerente_seleccionado, setUUIDGerente_seleccionado ] = useState<string>('')
  const verDetalleGerente = (uuid_gerente:string)=>{
    setUUIDGerente_seleccionado(uuid_gerente)
    setShowModalListaGerente(true)
  }

  const handleCloseCaratulaModal = () =>{
    setShowModalListaGerente(false)
  }

  const [ showModalListaAsesor, setShowModalListaAsesor ] = useState<boolean>(false)
  // const [ uuid_gerente_seleccionado, setUUIDGerente_seleccionado ] = useState<string>('')
  const verDetalleAsesor = (uuid_gerente:string)=>{
    setUUIDGerente_seleccionado(uuid_gerente)
    setShowModalListaAsesor(true)
  }

  const handleCloseListaAsesorModal = () =>{
    setShowModalListaAsesor(false)
  }






      return (
          <>


            <div className="container">
              
                <h3>Informe de Producción</h3>
                {
                  // JSON.stringify(etiquetas_seleccionadas)
                }








                <div className="row">
                    <div className="col">
                      
                        <div className="mb-3">
                            <label className="form-label">Fecha y Hora de la Noticia</label>

                          <DatePicker
                          className="form-control"
                            onChange={onChangeRango}
                            startDate={startDate}
                            endDate={endDate}
                            
                            selectsRange
                            
                          />
                        </div>



                    </div>
                    <div className="col-sm-8">
                      

                    <div className="mb-3">
                      <label className="form-label">Filtro por Sucursal</label>

                          <div className="hstack gap-3">

                              <Select
                                isMulti
                                defaultValue={defaultValue}
                                onChange={(opt:any,e:any)=>{ setEtiquetasSeleccionada(opt) }}
                                isClearable={true}
                                name="colors"
                                options={sucursales}
                                className="basic-multi-select"
                                classNamePrefix="select"
                              />
                                                 

                            <button type="button" onClick={(e:any)=>{cargarMiReporte()}} className="btn btn-secondary">Cargar</button>
                          </div>

                    </div>


                    </div>
                </div>




                              <div className="row">
                                  
                                  <div className="col">
                                    
                                      <div key={`inline-checkbox`} className="">

                                      {
                                        // JSON.stringify(arreglo_estatus)
                                      }


                                        <Form.Check
                                          inline
                                          name="group1"
                                          type="checkbox"
                                          label="CAPTURA"
                                          checked={arreglo_estatus[0]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[0] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_1`}
                                        />

                                        <Form.Check
                                          inline
                                          name="group2"
                                          type="checkbox"
                                          label="MESA DE ATENCIÓN"
                                          checked={arreglo_estatus[1]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[1] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_2`}
                                        />

                                        <Form.Check
                                          inline
                                          name="group3"
                                          type="checkbox"
                                          label="RECTIFICACIÓN"
                                          checked={arreglo_estatus[2]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[2] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_3`}
                                        />

                                        <Form.Check
                                          inline
                                          name="group4"
                                          type="checkbox"
                                          label="VERIFICACIÓN TELEFÓNICA"
                                          checked={arreglo_estatus[3]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[3] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_4`}
                                        />

                                        <Form.Check
                                          inline
                                          name="group5"
                                          type="checkbox"
                                          label="ASEGURAMIENTO"
                                          checked={arreglo_estatus[4]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[4] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_5`}
                                        />

                                        <Form.Check
                                          inline
                                          name="group6"
                                          type="checkbox"
                                          label="PRODUCCIÓN ACEPTADA"
                                          checked={arreglo_estatus[5]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[5] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_6`}
                                        />

                                        <Form.Check
                                          inline
                                          name="group7"
                                          type="checkbox"
                                          label="POR COBRAR"
                                          checked={arreglo_estatus[6]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[6] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_7`}
                                        />

                                        <Form.Check
                                          inline
                                          name="group8"
                                          type="checkbox"
                                          label="LIQUIDADO"
                                          checked={arreglo_estatus[7]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[7] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_8`}
                                        />

                                        <Form.Check
                                          inline
                                          name="group10"
                                          type="checkbox"
                                          label="CANCELADO"
                                          checked={arreglo_estatus[8]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[8] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_10`}
                                        />


                                        <Form.Check
                                          inline
                                          name="group9"
                                          type="checkbox"
                                          label="PENALIZADO"
                                          checked={arreglo_estatus[9]}
                                          onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[9] = e.target.checked;  setEstatus(ne);}}
                                          id={`opciones_9`}
                                        />

                                        
                                      </div>

                                    <ul className="list-inline">
                                      <li className="list-inline-item"><small className="cursor" onClick={()=>{todos()}}>Todos</small> / <small className="cursor" onClick={()=>{ninguno()}}>Ninguno</small></li>
                                      <li className="list-inline-item"><button type="button" onClick={()=>{descargarReporte()}} className="btn btn-sm btn-link">Descargar <i className="fa fa-file-excel-o" /></button></li>
                                    </ul>

                                      <p className="mb-3">
                                        
                                      </p>

                                  </div>

                              </div>







                <div className="row">
                    <div className="col">


                          {  (!cargando_ && reporte.hay_reporte ) && (

                                <>


                                    <h4 className="mt-4">
                                      {
                                        moment(startDate_).format('YYYY-MM-DD') !== moment(endDate_).format('YYYY-MM-DD') && ('REPORTE ENTRE '+ moment(startDate_).format('DD [DE] MMMM [DEL] YYYY').toUpperCase() + ' Y EL ' + moment(endDate_).format('DD [DE] MMMM [DEL] YYYY').toUpperCase() )
                                      }
                                      {
                                        moment(startDate_).format('YYYY-MM-DD') === moment(endDate_).format('YYYY-MM-DD') && ('REPORTE PARA EL '+moment(startDate_).format('DD [DE] MMMM [DEL] YYYY').toUpperCase())
                                      }
                                    </h4>

                                     {
                                       // JSON.stringify(etiquetas_seleccionadas)
                                     }

                                     {
                                       etiquetas_seleccionadas_.length > 0 && (

                                           <p>
                                     {
                                       // JSON.stringify(etiquetas_seleccionadas_)
                                     }        
                                             {
                                               etiquetas_seleccionadas_.map( (sucursal:any) =>

                                                   <span key={ Math.random().toString(36).substr(2, 9) } className="badge bg-primary" style={{marginRight:10}}>{sucursal.label}</span> 

                                                )
                                             }
                                           </p>
                                         )
                                     }

                                     {
                                       // JSON.stringify(reporte.RowsAcumuladosTotales)
                                     }




                                    <table className="table">
                                      <thead style={{"fontSize":8}}>
                                        <tr>
                                          <th scope="col">Gerente</th>
                                          <th scope="col">Total de Tramites</th>


                                            { arreglo_estatus[0] && ( <th scope="col" className={'estatus_1 v text-center'}>En captura</th> ) }
                                            { arreglo_estatus[1] && ( <th scope="col" className={'estatus_2 v text-center'}>Mesa de atención</th> )}
                                            { arreglo_estatus[2] && ( <th scope="col" className={'estatus_3 v text-center'}>Retificación</th> )}
                                            { arreglo_estatus[3] && ( <th scope="col" className={'estatus_8 v text-center'}>Verificación telefónica</th> )}
                                            { arreglo_estatus[4] && ( <th scope="col" className={'estatus_4 v text-center'}>Aseguramiento</th> )}
                                            { arreglo_estatus[5] && ( <th scope="col" className={'estatus_9 v text-center'}>Producción aceptada</th> )}
                                            { arreglo_estatus[6] && ( <th scope="col" className={'estatus_5 v text-center'}>Por cobrar</th> )}
                                            { arreglo_estatus[7] && ( <th scope="col" className={'estatus_6 v text-center'}>Liquidado</th> )}
                                            { arreglo_estatus[8] && ( <th scope="col" className={'estatus_999 v text-center'}>Cancelado</th> )}
                                            { arreglo_estatus[9] && ( <th scope="col" className={'estatus_7 v text-center'}>Penalizado</th> )}

                                          {
                                            // reporte.estatus.map(estatus =>

                                            //     <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
                                            //       <th scope="col" className={'estatus_'+(estatus.id)+' v text-center'}>
                                            //         {estatus.estatus}
                                            //       </th>
                                            //     </React.Fragment>

                                            // )
                                          }

                                        </tr>
                                      </thead>
                                      <tbody>


                                                      <tr className="table-primary" key={ Math.random().toString(36).substr(2, 9) }>
                                                        <td className="v text-right" style={{fontSize:17}}><b>TOTAL DE TRÁMITES</b> </td>
                                                        <td className="v text-center" style={{fontSize:17}}>
                                                            {
                                                              (
                                                                reporte.RowsAcumuladosTotales.total_captura + 
                                                                reporte.RowsAcumuladosTotales.total_mesa + 
                                                                reporte.RowsAcumuladosTotales.total_rectificacion + 
                                                                reporte.RowsAcumuladosTotales.total_verificacion_telefonica + 
                                                                reporte.RowsAcumuladosTotales.total_aseguramiento + 
                                                                reporte.RowsAcumuladosTotales.total_verificacion_final + 
                                                                reporte.RowsAcumuladosTotales.total_sin_pagar + 
                                                                reporte.RowsAcumuladosTotales.total_liquidado + 
                                                                reporte.RowsAcumuladosTotales.total_canceladas + 
                                                                reporte.RowsAcumuladosTotales.total_penalizado 
                                                                )
                                                            }

                                                        </td>

                                                        { arreglo_estatus[0] && ( <td style={{width:65, fontSize: 17}} className="v text-center"><b>{reporte.RowsAcumuladosTotales.total_captura}</b></td>) }
                                                        { arreglo_estatus[1] && ( <td style={{width:65, fontSize: 17}} className="v text-center"><b>{reporte.RowsAcumuladosTotales.total_mesa}</b></td> )}
                                                        { arreglo_estatus[2] && ( <td style={{width:65, fontSize: 17}} className="v text-center"><b>{reporte.RowsAcumuladosTotales.total_rectificacion}</b></td> )}
                                                        { arreglo_estatus[3] && ( <td style={{width:65, fontSize: 17}} className="v text-center"><b>{reporte.RowsAcumuladosTotales.total_verificacion_telefonica}</b></td> )}
                                                        { arreglo_estatus[4] && ( <td style={{width:65, fontSize: 17}} className="v text-center"><b>{reporte.RowsAcumuladosTotales.total_aseguramiento}</b></td> )}
                                                        { arreglo_estatus[5] && ( <td style={{width:65, fontSize: 17}} className="v text-center"><b>{reporte.RowsAcumuladosTotales.total_verificacion_final}</b></td> )}
                                                        { arreglo_estatus[6] && ( <td style={{width:65, fontSize: 17}} className="v text-center"><b>{reporte.RowsAcumuladosTotales.total_sin_pagar}</b></td> )}
                                                        { arreglo_estatus[7] && ( <td style={{width:65, fontSize: 17}} className="v text-center"><b>{reporte.RowsAcumuladosTotales.total_liquidado}</b></td> )}
                                                        { arreglo_estatus[8] && ( <td style={{width:65, fontSize: 17}} className="v text-center"><b>{reporte.RowsAcumuladosTotales.total_canceladas}</b></td> )}
                                                        { arreglo_estatus[9] && ( <td style={{width:65, fontSize: 17}} className="v text-center"><b>{reporte.RowsAcumuladosTotales.total_penalizado}</b></td> )}

                                                      </tr>

                                        {
                                          reporte.RowsAcumulados.map( asociado => 

                                              <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>

                                              {
                                                asociado.total > 0 && (

                                                  <React.Fragment>

                                                      <tr className="table-primary" key={ Math.random().toString(36).substr(2, 9) }>
                                                        <td className="v" style={{fontSize:14}}><b>{asociado.nombres}</b> <small>{asociado.paterno} {asociado.materno}</small></td>
                                                        <td className="v text-center"><b className="cursor" onClick={()=>{verDetalleGerente(asociado.uuid)}}>{asociado.total}</b></td>




                                                        { arreglo_estatus[0] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_captura}</b></td> )}
                                                        { arreglo_estatus[1] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_mesa}</b></td> )}
                                                        { arreglo_estatus[2] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_rectificacion}</b></td> )}
                                                        { arreglo_estatus[3] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_verificacion_telefonica}</b></td> )}
                                                        { arreglo_estatus[4] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_aseguramiento}</b></td> )}
                                                        { arreglo_estatus[5] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_verificacion_final}</b></td> )}
                                                        { arreglo_estatus[6] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_sin_pagar}</b></td> )}
                                                        { arreglo_estatus[7] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_liquidado}</b></td> )}
                                                        { arreglo_estatus[8] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_canceladas}</b></td> )}
                                                        { arreglo_estatus[9] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asociado.total_penalizado}</b></td> )}


                                                      </tr>

                                                {
                                                  asociado.asesores.map( asesor =>


                                                    
                                                      <tr key={ Math.random().toString(36).substr(2, 9) }>
                                                        <td className="v" style={{fontSize:12}}><b>{asesor.nombres}</b> <small>{asesor.paterno} {asesor.materno}</small></td>
                                                        <td className="v text-center"><b className="cursor" onClick={()=>{verDetalleAsesor(asesor.uuid)}}><small>{asesor.total}</small></b></td>

                                                        { arreglo_estatus[0] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_captura}</b></td> )}
                                                        { arreglo_estatus[1] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_mesa}</b></td> )}
                                                        { arreglo_estatus[2] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_rectificacion}</b></td> )}
                                                        { arreglo_estatus[3] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_verificacion_telefonica}</b></td> )}
                                                        { arreglo_estatus[4] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_aseguramiento}</b></td> )}
                                                        { arreglo_estatus[5] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_verificacion_final}</b></td> )}
                                                        { arreglo_estatus[6] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_sin_pagar}</b></td> )}
                                                        { arreglo_estatus[7] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_liquidado}</b></td> )}
                                                        { arreglo_estatus[8] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_canceladas}</b></td> )}
                                                        { arreglo_estatus[9] && ( <td style={{width:65, fontSize: 12}} className="v text-center"><b>{asesor.total_penalizado}</b></td> )}



                                                      </tr>


                                                  )
                                                }

                                                  </React.Fragment> 


                                                )
                                              }
                                              

                                              </React.Fragment>

                                            )
                                        }

                                      </tbody>
                                    </table>
                                    




                                </>

                             )
                        }

                          {  cargando_ && (

                              <>
                                <div className="loader">
                                  <div className="loaderBar"></div>
                                </div>
                              </>


                           )}

                          { (!cargando_ && !reporte.hay_reporte) && (


                              <div className="alert alert-dismissible alert-warning">
                                <h4 className="alert-heading">...</h4>
                                <p className="mb-0">No tenemos reporte para este día</p>
                              </div>


                           )}


                    </div>

                </div>

            </div>
              
                
              









          </>

      );
  

}

export default DirectorComercial
